export default "{\n    \"emptyText\": \"Click to select a facility\",\n    \"searchPlaceholderText\": \"Search by name or address\"\n}\n"